var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconawesomePlusSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-plus-square",
    "data-name": "Icon awesome-plus-square",
    d: "M19.643,2.25H2.357A2.358,2.358,0,0,0,0,4.607V21.893A2.358,2.358,0,0,0,2.357,24.25H19.643A2.358,2.358,0,0,0,22,21.893V4.607A2.358,2.358,0,0,0,19.643,2.25ZM18.071,14.625a.591.591,0,0,1-.589.589H12.964v4.518a.591.591,0,0,1-.589.589H9.625a.591.591,0,0,1-.589-.589V15.214H4.518a.591.591,0,0,1-.589-.589v-2.75a.591.591,0,0,1,.589-.589H9.036V6.768a.591.591,0,0,1,.589-.589h2.75a.591.591,0,0,1,.589.589v4.518h4.518a.591.591,0,0,1,.589.589Z",
    transform: "translate(0 -2.25)",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomePlusSquare);
export default __webpack_public_path__ + "static/media/Icon awesome-plus-square.9ea363aa6334b4b323e878f9e899163a.svg";
export { ForwardRef as ReactComponent };